import { render } from "./ScheduleFormPage.vue?vue&type=template&id=04fe64a3"
import script from "./ScheduleFormPage.vue?vue&type=script&lang=ts"
export * from "./ScheduleFormPage.vue?vue&type=script&lang=ts"
script.render = render

export default script